import { DELETE_STAFF_START } from '../../types';

export const delete_staff = (payload) => ({
  type: DELETE_STAFF_START,
  payload,
});
